import { render, staticRenderFns } from "./AccountExpiration.vue?vue&type=template&id=d2540f4c&"
import script from "./AccountExpiration.vue?vue&type=script&lang=js&"
export * from "./AccountExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountExpiration.vue"
export default component.exports